import React, { ReactNode } from 'react';
import Box from '../Box';
import ImageBox from '../ImageBox';
import { Image } from '../Image';
import { formatImage } from '../../utils/image';
import Distance from '../Distance';
import Text from '../Text';
import ContentBlock from '../ContentBlock';
import { Configuration, ConfigurationsWrapper } from './wrappers';
import { Column, Columns } from '../Columns/wrappers';
import ProductPrices, { PriceObject } from '../../components-legacy/ProductPrices';
import Button from '../Button';

interface IVariantPanelOption {
  imageUrl: string;
  variantName: string;
  variantDescription: string;
  variantConfigurations?: { label: string; value: string }[];
  variantInfo: string;
  buttonContent: ReactNode | string;
  onClickButton: () => void;
  buttonTone?: 'positive';
  disableButton?: boolean;
  priceObject?: PriceObject;
}

export default function VariantPanelOption({
  imageUrl,
  variantName,
  variantDescription,
  variantInfo,
  variantConfigurations,
  priceObject,
  buttonContent,
  onClickButton,
  buttonTone,
  disableButton,
}: IVariantPanelOption) {
  return (
    <Box background="main" padding="y">
      <ImageBox height="150px">
        <Image
          widthAuto
          src={formatImage(imageUrl, {
            height: 300,
            cdn: true,
            output: 'jpg',
          })}
        />
      </ImageBox>

      <Distance size="3" />

      <Text size={['standard', 'large']} weight="medium">
        {variantName}
      </Text>
      <Text size={['standard', 'large']} weight="thin">
        {variantDescription}
      </Text>

      {variantConfigurations && (
        <>
          <Distance size="2" />
          <ContentBlock maxWidth="316px">
            <ConfigurationsWrapper>
              {variantConfigurations.map((variantConfiguration) => (
                <Configuration key={variantConfiguration.label + variantConfiguration.value}>
                  <Text size={['xsmall', 'small']} tone="alt">
                    {variantConfiguration.label}
                  </Text>

                  <Text size={['xsmall', 'small']} weight="medium">
                    {variantConfiguration.value}
                  </Text>
                </Configuration>
              ))}
            </ConfigurationsWrapper>
          </ContentBlock>
        </>
      )}

      {!variantConfigurations && (
        <>
          <Distance size="1" />
          <Text size={['xsmall', 'small']} weight="medium">
            {variantInfo}
          </Text>
        </>
      )}

      <Distance />

      <Columns className="spacebtw-center space-1">
        {priceObject && (
          <Column>
            <ProductPrices priceObject={priceObject} />
          </Column>
        )}
        <Column>
          <Button rounded tone={buttonTone} onClick={onClickButton} disabled={disableButton}>
            {buttonContent}
          </Button>
        </Column>
      </Columns>
    </Box>
  );
}
